
import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import registerServiceWorker from './registerServiceWorker';
import ServiceWorkerState from "./framework/ServiceWorkerState";

const serviceProviderState = {outofDate: false, msg: ''};
const ServiceWorkerContext = React.createContext(serviceProviderState);

ReactDOM.render(<ServiceWorkerState.Provider value={serviceProviderState}><App /></ServiceWorkerState.Provider>, document.getElementById('root'));

const callback = (outOfDate, msg)=> {
       console.log('service worker state change', msg);
       serviceProviderState.outOfDate = outOfDate;
       serviceProviderState.mg = msg;
};
registerServiceWorker(callback);


